module.exports = __webpack_public_path__ + "img/go-build-old.cb3b10ae.jpg";